export default __webpack_public_path__ + "static/googleoffice-a3c33b77ce1f02d4e42aa00954a464fd.png";